import React from 'react';
import styles from './styles.scss';
import { useTranslation } from 'hooks/use-translation';
const EmptyImg = 'https://web-data.zmlearn.com/image/2KtBxsc45mowqx5JdSFHux/img_default_noclass.png';

/**
 * 课程页面
 */
export default function EmptyComponent() {
	const { transData } = useTranslation('perfilAndAjustes');
	return (
		<div className={styles.empty_warp}>
			<img src={EmptyImg} alt="Empty" />
			<p>{transData.coursesEmpty}</p>
		</div>
	);
}
